export enum LizenzEnum {
    PRO = "PRO",
    KURSE = "KURSE",
    FREE = "free",
}
